import React from "react";
import { MessageModal } from "@blacknut/react-sdk";
import { useSelector } from "react-redux";
import { State } from "core/redux";
import { useProfiles } from "core/hooks";
import { useTranslation } from "react-i18next";

interface SwitchToMasterModalProps {
  redirectUrl: string;
  closeModal: () => void;
  isOpen: boolean;
}

const SwitchToMasterModal = (props: SwitchToMasterModalProps) => {
  const { closeModal, redirectUrl } = props;
  const { familyProfiles } = useSelector((state: State) => state.profilesState);
  const masterProfile = familyProfiles.profiles?.find((p) => p.isMaster);
  const { onSelectProfile } = useProfiles();
  const { t } = useTranslation();

  return (
    <MessageModal
      {...props}
      title={t("dialogs.unlockPass.title")}
      message={t("dialogs.unlockPass.message")}
      onPressPositive={async () => {
        if (masterProfile) {
          closeModal();
          await onSelectProfile(masterProfile, redirectUrl);
        }
      }}
      onPressNegative={closeModal}
      onClose={closeModal}
      positiveButtonText={t("buttons.switchUser")}
      negativeButtonText={t("buttons.cancel")}
    />
  );
};

export default SwitchToMasterModal;
